import { format, formatDistanceToNow } from "date-fns"

import type { LinearDateResolution } from "@productlane/db"

// Formats a given due date according to its resolution (month, quarter, etc.)
// Returns a string like "in March", "in Q2", "in 2 months", etc.
export function getFormattedDueDate(
	date: Date,
	resolution: LinearDateResolution | null,
): string {
	const currentYear = new Date().getFullYear()
	let formattedDate = ""

	const quarter = Math.ceil((date.getMonth() + 1) / 3)
	const half = date.getMonth() < 6 ? "H1" : "H2"

	switch (resolution) {
		case null:
			formattedDate = formatDistanceToNow(date)
			break
		case "month":
			formattedDate =
				currentYear === date.getFullYear()
					? format(date, "MMMM")
					: format(date, "MMMM yyyy")
			break
		case "quarter":
			formattedDate =
				currentYear === date.getFullYear()
					? `Q${quarter}`
					: `Q${quarter} ${date.getFullYear()}`
			break
		case "halfYear":
			formattedDate =
				currentYear === date.getFullYear()
					? `${half}`
					: `${half} ${date.getFullYear()}`
			break
		case "year":
			formattedDate = `${date.getFullYear()}`
			break
		default:
			formattedDate = "unknown"
			break
	}

	return `in ${formattedDate}`
}
